/**
 * recommendations.js
 *
 * This script builds and manages the Slideview right rail content using
 * Handlebars templating with data coming from various sources. We're
 * migrating one type of data at a time so this file will continue to
 * evolve as new data is managed.
 */
(function($, ss, jSecure) {

  var DATA_ID = 'recommendations-api-content',
      utils = ss.utils,
      RecommendationsTracker = utils.imports('tracking.Recommendations'),
      recommendationsTemplate = utils.imports('templates.recommendations.base');

  /**
   * Attached an 'i18n' key to a JSON object which contains all values
   * stored in the i18n JS utility.
   * @param {Object} json The object you wish to append i18n data to.
   * @returns {Object}
   */
  function attachI18n(json) {
    json.i18n = utils.i18n();
    return json;
  }

  /**
   * Parses JSON data embedded within a script element, passing it through
   * an XSS library for unencoding and appending an i18n object to the
   * parsed data.
   * @param {String} dataId The id of a DOM element containing JSON data.
   * @returns {Object}
   */
  function generateData(dataId) {
    var dataEl = document.getElementById(dataId);
    if (dataEl) {
      return attachI18n(
        JSON.parse(
          jSecure.htmlUnencode(dataEl.innerHTML.replace(/<!-+?({.*})-+>/,"$1"))
        )
      );
    }
    return null;
  }

  /**
   * A temporary function for creating a new RecommendationsTracker.
   * @todo Remove this function once the new right rail has fully ramped.
   * @param {Object} config
   * @returns {RecommendationsTracker}
   */
  function generateTracker(config) {
    return new RecommendationsTracker({
      slideshowId: config.slideshowId,
      designKey: config.designKey,
      finalRankerModel: config.finalRankerModel
    });
  }

  /**
   * This component generates the SlideView right rail using embedded JSON with
   * Handlebars templates.
   * @param {String} selector The element selector where the right rail should be rendered.
   * @constructor
   */
  function Recommendations(selector) {

    var data = generateData(DATA_ID),
        templateString = data ? recommendationsTemplate(data) : null;

    // If the template exists, that means we found the Fizzy data. Render the new rail!
    if (templateString) {
      this._$el = $(selector);
      this._$el.html(templateString);
      this._processContent(data);
      // Trigger lazyload for thumbnails
      ss.lazyloadThumbnails();
    }

    // Otherwise, business as usual. Well, almost. I've refactored the RecommendationsTracker
    // to handle both cases (old rail and new rail) so now we need to instantiate it.
    // We'll do so here with data found on the slideshare_object.
    // TODO: Remove this when the new rail ramps to 100%.
    else {
      generateTracker({
        slideshowId: ss.slideshow.id,
        designKey: ss.slideshow.recommendations.designKey,
        finalRankerModel: ss.slideshow.recommendations.finalRankerModel
      });
    }
  }

  Recommendations.prototype = {

    constructor: Recommendations,

    /**
     * Currently, this is a catch-all for further configuration needs based on the
     * recommendations data. Will probably need to be refactored as it grows but it
     * should suffice for now.
     * @param {Object} data The recommendations data.
     * @private
     */
    _processContent: function(data) {
      // If an ad exists, add it to the queue for processing.
      if (data.show_ad && data.sv_ad_hash) {
        ss.processAdQueue([data.sv_ad_hash]);
      }

      // Fire up the tracker!
      generateTracker({
        slideshowId: data.slideshow_id,
        designKey: data.design_key,
        finalRankerModel: data.final_ranker_model
      });
    }

  };

  utils.exports('slideview.Recommendations', Recommendations);

}(
  window.$,
  window.slideshare_object,
  window.jSecure
));
